// setShouldDisplayExclusiveRevisionTooltip.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display the exclusive-revision tooltip (one-off livestream revamp hint).
 * @kind action
 * @param {boolean} shouldDisplayExclusiveRevisionTooltip - If true, the hint will be shown; otherwise, it will be hidden.
 * @return {Promise} Action promise.
 */
const setShouldDisplayExclusiveRevisionTooltip =
  ({ shouldDisplayExclusiveRevisionTooltip }) =>
  async dispatch =>
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayExclusiveRevisionTooltip,
        },
      },
    });
export default setShouldDisplayExclusiveRevisionTooltip;
